import { render, staticRenderFns } from "./Warnings.vue?vue&type=template&id=92f0a4f2&"
import script from "./Warnings.vue?vue&type=script&lang=js&"
export * from "./Warnings.vue?vue&type=script&lang=js&"
import style0 from "./Warnings.vue?vue&type=style&index=0&id=92f0a4f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports